export const getProductById = (invoices?: InvoiceParamsOutput[], invoiceId?: number, productId?: number) => {
  if (!invoices || !invoiceId || !productId) {
    return;
  }
  const invoice = invoices?.find((invoice: InvoiceParamsOutput) => invoice.id === invoiceId);
  return invoice?.products?.find((product: ProductParamsOutput) => product.id === productId);
}
